import { recordTrack } from '@saucelabs/sl-util-segmentio';

const MANUAL_PREFIX = 'Manual - ';

export const NAVIGATION_EVENTS = Object.freeze({
  MANUAL_JOB: 'Manual Test Results - Navigate to Manual Test',
  VIEW_JOB_LIST: `${MANUAL_PREFIX}View Job List`,
  VIEW_JOB_DETAILS: 'nav/view/job-details',
  VIEW_RUNNING_JOB: 'nav/view/job-running',
});

export const JOB_TYPES = Object.freeze({
  AUTOMATED: 'automated',
  MANUAL: 'manual',
  RDC: 'rdc',
});

// Mirror from packages/web-ui-manual/src/constants
export const CONFIGURATION_TEST_TYPES = Object.freeze({
  APP: 'APP',
  WEB: 'WEB',
});

export const JOBS_UI_ELEMENTS = Object.freeze({
  NEW_WEB_TEST_BUTTON_BREADCRUMB: 'Breadcrumb New Live Web Test Button',
  NEW_APP_TEST_BUTTON_BREADCRUMB: 'Breadcrumb New Live App Test Button',
  NEW_WEB_TEST_BUTTON_EMPTY_STATE: 'Empty State New Live Web Test Button',
  NEW_APP_TEST_BUTTON_EMPTY_STATE: 'Empty State New Live App Test Button',
});

export const DOCUMENTATION_EVENTS = Object.freeze({
  HELPFUL_RESOURCE: `${MANUAL_PREFIX}Select Helpful Resources`,
  SUPPORT_PORTAL: 'docs/click/getting-started__support-portal',
  DOCUMENTATION_WIKI: 'docs/click/getting-started__documentation',
  REFER_A_FRIEND: 'docs/click/getting-started__refer-a-friend',
  ANNOTATING_TESTS: 'docs/click/automated__builds__annotate-tests-button',
  RDC_TESTS: 'docs/click/automated__test-results__real-devices__detailed-info-link',
});

export const ONBOARDING_EVENTS = Object.freeze({
  VIDEO_LOADED: 'Onboarding-Video-Loaded',
  VIDEO_PLAYED: 'Onboarding-Video-Played',
  VIDEO_ENDED: 'Onboarding-Video-Ended',
  DOCUMENTATION_OPEN: 'docs/click/automated__test-results__virtual-cloud__documentation-link',
});

export const SUBACCOUNT_DASHBOARD_EVENTS = Object.freeze({
  ADMIN_VISIT: 'subaccount_dashboard_deprecated_view/visit/admin_account',
  USER_VISIT: 'subaccount_dashboard_deprecated_view/visit/user_account',
});

export const trackEvent = recordTrack;
export default trackEvent;
